export default __webpack_public_path__ + "static/media/PT1.27ed1555.webp";